module.exports = __webpack_public_path__ + "static/media/PDF_103.8d0cd0bf.pdf";